import { isBrowser } from './utils';

export class GoogleApiScriptClass {
  isInitialised = false;
  private subscribers: { [key: string]: (() => void)[] } = {};

  onUpdateObserverValue<T>(key: string) {
    if (this.subscribers[key]) {
      this.subscribers[key].forEach((cb) => cb());
    }
  }

  subscribe(key: 'init', cb: () => void) {
    if (this.isInitialised) {
      cb();
    } else {
      this.subscribers[key] = [...(this.subscribers[key] || []), cb];
    }
  }

  unsubscribe(key: string, cb: () => void) {
    if (this.subscribers[key]) {
      this.subscribers[key] = this.subscribers[key].filter(
        (subscriber) => subscriber !== cb,
      );
    }
  }

  private onScriptInit = () => {
    this.isInitialised = true;
    this.onUpdateObserverValue('init');
    this.subscribers = {};
  };

  init(language?: string) {
    if (this.isInitialised) {
      return;
    }
    const placeDiv = document.getElementById('places_service');
    if (!isBrowser || (typeof google !== 'undefined' && google?.maps))
      return this.onScriptInit();

    if (!placeDiv) {
      const newPlaceDiv = document.createElement('div');
      newPlaceDiv.id = 'places_service';
      document.body.appendChild(newPlaceDiv);
    }

    const script = document.getElementById('google_api');

    if (script) {
      return;
    }

    if (process.env.REACT_APP_GOOGLE_API_KEY) {
      const newScript = document.createElement('script');
      newScript.src = `https://maps.googleapis.com/maps/api/js?key=${
        process.env.REACT_APP_GOOGLE_API_KEY
      }&libraries=places${
        language ? `&language=${language}` : ''
      }&callback=initGooglePlaces`;
      newScript.async = true;
      newScript.id = 'google_api';
      (window as any).initGooglePlaces = () => {
        this.onScriptInit();
      };
      document.body.appendChild(newScript);
      return;
    }

    return;
  }
}

export const GoogleApiScript = new GoogleApiScriptClass();
